import React from 'react';
import { CircularProgress } from '@material-ui/core';
import styles from './styles.module.scss';
import ctx from 'classnames';
import { ButtonVariant, CoreButton } from '@clover/web-lib-core/components';

interface ComponentProps extends React.HTMLAttributes<HTMLButtonElement> {
  isLoading?: boolean;
  text?: string;
  variant?: ButtonVariant;
  isDisabled?: boolean;
  hideTextWhileLoading?: boolean;
}

const LoadingButton = (props: ComponentProps): JSX.Element => {
  let { isLoading, text, variant, isDisabled, hideTextWhileLoading, ...rest } = props;
  variant = variant !== undefined ? variant : ButtonVariant.PRIMARY;
  const hideText = isLoading && hideTextWhileLoading;
  return (
    <CoreButton className={styles.loadingButton} variant={variant} disabled={!!isDisabled} {...rest}>
      {isLoading && <CircularProgress color='inherit' size={20} />}
      {!hideText && <span className={ctx({ [styles.loading]: isLoading })}>{text || ''}</span>}
    </CoreButton>
  );
};

export default LoadingButton;
